var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_vm.globalStore.cooperation)?_c('Header'):_vm._e(),_c('router-view'),_c('Footer'),_c('SemiLoginModal',{attrs:{"open":_vm.semiLoginModalOpen}}),_c('BusinessDetailsModal',{attrs:{"open":_vm.businessDetailsModalOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }